import Navbar from "./components/Navbar";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import AboutUs from "./pages/About";
import Footer from "./components/Footer";
import { useEffect, useState } from "react";
import Maintenance from "./pages/Maintenance";
import SiddharthPTCCollege from "./pages/SiddharthPTCCollege";

function App() {
  const [isAllowed, setIsAllowed] = useState(true); // Default to true for dev mode

  useEffect(() => {
    fetch(
      "https://raw.githubusercontent.com/RutvinBhanderi/client-status/refs/heads/main/status.json"
    )
      .then((res) => res.json())
      .then((data) => {
        console.log("data", data);
        if (!data.isActive) {
          setIsAllowed(false);
        }
      })
      .catch(() => {
        console.log("error");
      }); // If fetch fails, assume blocked
  }, []);
  return (
    <div>
      <Router>
        <Navbar />
        <Routes>
          {!isAllowed ? (
            <>
              <Route path="*" element={<Maintenance />} />
            </>
          ) : (
            <>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<AboutUs />} />
              <Route path="/siddharth-ptc-collage" element={<SiddharthPTCCollege />} />
            </>
          )}
        </Routes>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
